import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, InputNumber } from 'antd';
import { CONFKEY_LABEL_MAP } from './constants';
import { toLower } from '../../../util/lodashlike';

const FormItem = ({ confKey = '', type = 'text' }) => {
  const labelText = CONFKEY_LABEL_MAP[confKey] || confKey;
  const inputType = toLower(type);

  return (
    <Form.Item
      label={labelText}
      name={confKey}
      rules={[
        {
          required: true,
          message: `${labelText} is required.`
        }
      ]}>
      {inputType === 'text' && <Input />}
      {inputType === 'number' && <InputNumber style={{ width: '100%' }} />}
    </Form.Item>
  );
};

FormItem.propTypes = {
  confKey: PropTypes.string,
  type: PropTypes.string
};

export default FormItem;
